import React from "react";

import NewsJobRequestPage from "./NewsJobRequestPage";

export default function RequestNewsPage() {
  return <NewsJobRequestPage mode="news" />;
}
